import React, { useEffect, useState } from "react";
import { Row, Col, Card, Typography, Select, Button } from "antd";
import LeadCard from "./LeadCard";
import AdminCard from "./AdminCard";
import { FilterOutlined } from "@ant-design/icons";
import "./newDashboard.css";
import { useLocation, useNavigate } from "react-router-dom";

export default function NewDashboard() {
  const location = useLocation();
  const [selectedLead, setSelectedLead] = useState(null);
  const [filters, setFilters] = useState({
    location: null,
    landType: null,
    budget: null,
    plotSize: null,
  });
  const { Title } = Typography;
  const navigate = useNavigate();
  const leadDetails = [
    {
      id: 1,
      name: "John Doe",
      place: "New York",
      rating: "3/5",
      price: "200",
      landType: "Villa",
      status: "Intake",
    },
    {
      id: 2,
      name: "Jane Smith",
      place: "London",
      rating: "4/5",
      price: "350",
      landType: "Coastal Land",
      status: "Qualified",
    },
    {
      id: 3,
      name: "Michael Lee",
      place: "Tokyo",
      rating: "5/5",
      price: "500",
      landType: "Plot Layout",
      status: "Qualified",
    },
    {
      id: 4,
      name: "Sara Khan",
      place: "Dubai",
      rating: "2/5",
      price: "150",
      status: "Qualified",
    },
  ];
  const [leads, setLeads] = useState(leadDetails);

  useEffect(() => {
    if (location.state?.filters) {
      const f = location.state.filters;
      const hasAny =
        f.state ||
        f.district ||
        f.area ||
        f.pincode ||
        f.radius ||
        (f.landType && f.landType.length > 0) ||
        (f.plotSize && f.plotSize.length > 0) ||
        (f.budget && f.budget.length > 0);

      if (hasAny) {
        setFilters(f);
      } else {
        // reset if nothing selected
        setFilters({
          location: null,
          landType: null,
          budget: null,
          plotSize: null,
        });
      }
    }
  }, [location.state]);

  // Find lead with only 1 left (rating = "4/5")
  const priorityLead = leadDetails.find((lead) => {
    const [purchased, total] = lead.rating.split("/").map(Number);
    return total - purchased === 1; // 1 left
  });

  // If none found → choose random
  const adminLead = priorityLead
    ? priorityLead
    : leadDetails[Math.floor(Math.random() * leadDetails.length)];

  const filteredLeads = leadDetails.filter((lead) => {
    return (
      (!filters.location ||
        filters.location.length === 0 ||
        filters.location.includes(lead.place)) &&
      (!filters.landType ||
        filters.landType.length === 0 ||
        filters.landType.includes(lead.landType)) &&
      (!filters.budget ||
        filters.budget.length === 0 ||
        filters.budget.some((b) => Number(lead.price) <= Number(b))) &&
      (!filters.plotSize ||
        filters.plotSize.length === 0 ||
        filters.plotSize.some((s) => Number(lead.plotSize) >= Number(s)))
    );
  });

  const handleFilter = () => {
    navigate("/dashboard-filter");
  };

  const handleClearSearchFilter = () => {
    setFilters({
      location: null,
      landType: null,
      budget: null,
      plotSize: null,
    });
    navigate("/admin/new-dashboard", { replace: true, state: {} });
  };

  const afterLogin = true;

  const updateLeadStatus = (newStatus) => {
    setLeads((prev) =>
      prev.map((lead) =>
        lead.id === selectedLead.id ? { ...lead, status: newStatus } : lead
      )
    );

    // update selected lead also
    setSelectedLead({ ...selectedLead, status: newStatus });
  };

  return (
    <div style={{ padding: "10px" }}>
      {/* Page Title */}
      <Button
        onClick={() => {
          navigate("/admin/retail-admin-dashboard");
        }}
      >
        B
      </Button>
      <Button
        onClick={() => {
          navigate("/admin/after-login-web");
        }}
      >
        A
      </Button>
      <Row gutter={16} align="middle" style={{ marginBottom: "16px" }}>
        {/* Title on the left */}

        <Col span={6}>
          <Title level={4} style={{ margin: 0 }}>
            All Leads
          </Title>
        </Col>

        {/* Search bar on the right */}
        <Col span={14}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #DBEAFF",
              borderRadius: "6px",
              overflow: "hidden",
              background: "#fff",
              width: "100%",
            }}
          >
            <Select
              mode="multiple"
              className="custom-select"
              placeholder="Select Location"
              style={{
                flex: 1,
                borderRight: "1px solid #DBEAFF",
              }}
              value={filters.location}
              onChange={(value) => setFilters({ ...filters, location: value })}
              options={[
                { value: "New York", label: "New York" },
                { value: "London", label: "London" },
                { value: "Tokyo", label: "Tokyo" },
                { value: "Dubai", label: "Dubai" },
              ]}
            />
            <Select
              mode="multiple"
              className="custom-select"
              placeholder="Land Type"
              style={{ flex: 1, borderRight: "1px solid #DBEAFF" }}
              onChange={(value) => setFilters({ ...filters, landType: value })}
              options={[
                { value: "Villa", label: "Villa" },
                { value: "Apartment", label: "Apartment" },
                { value: "Flat", label: "Flat" },
              ]}
            />
            <Select
              mode="multiple"
              className="custom-select"
              placeholder="Budget Range"
              style={{ flex: 1, borderRight: "1px solid #DBEAFF" }}
              onChange={(value) => setFilters({ ...filters, budget: value })}
              options={[
                { value: "200", label: "≤ 200" },
                { value: "350", label: "≤ 350" },
                { value: "500", label: "≤ 500" },
              ]}
            />
            <Select
              mode="multiple"
              className="custom-select"
              placeholder="Plot Size"
              style={{ flex: 1, borderRight: "1px solid #DBEAFF" }}
              onChange={(value) => setFilters({ ...filters, plotSize: value })}
              options={[
                { value: "600", label: "≥ 600" },
                { value: "800", label: "≥ 800" },
                { value: "1000", label: "≥ 1000" },
              ]}
            />
            <Button
              type="primary"
              style={{
                background: "blue",
                border: "none",
                borderRadius: 0,
                padding: "0 24px",
              }}
            >
              Search
            </Button>
          </div>
        </Col>
        <Col span={2} style={{ paddingRight: "0" }}>
          <Button
            type="default"
            onClick={handleClearSearchFilter}
            style={{ border: "1px solid red", color: "red" }}
          >
            Clear
          </Button>
        </Col>
        <Col span={2}>
          <Button
            icon={<FilterOutlined />}
            type="default"
            onClick={handleFilter}
          >
            Filter
          </Button>
        </Col>
      </Row>

      <Row gutter={20}>
        {/* Left Column */}
        <Col span={6}>
          {filteredLeads.map((lead) => (
            <LeadCard
              key={lead.id}
              name={lead.name}
              place={lead.place}
              rating={lead.rating}
              price={lead.price}
              onClick={() => setSelectedLead(lead)}
            />
          ))}
        </Col>

        {/* Divider */}
        <Col flex="2px">
          <div
            style={{
              width: "2px",
              backgroundColor: "#DBEAFF",
              height: "100%",
            }}
          />
        </Col>

        {/* Right Column */}
        <Col span={17}>
          <Row gutter={20}>
            <Col span={24}>
              {selectedLead ? (
                <>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <Title level={4}>Lead Details</Title>
                    {afterLogin && (
                      <Select
                        className="custom-select"
                        placeholder="Select/update"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          border: "1px solid #DBEAFF",
                          borderRadius: "6px",
                          overflow: "hidden",
                          background: "#fff",
                          width: "20%",
                        }}
                        onChange={(value) => updateLeadStatus(value)}
                        options={[
                          { value: "Intake", label: "Intake" },
                          { value: "Qualified", label: "Qualified" },
                          { value: "RNR", label: "RNR" },
                          { value: "Disqualified", label: "Disqualified" },
                        ]}
                      />
                    )}
                  </div>
                  <Card
                    style={{
                      borderRadius: 6,
                      background: "#fafafa",
                      marginBottom: 20,
                    }}
                  >
                    <Row gutter={0}>
                      <Col
                        span={6}
                        style={{
                          borderRight: "1px solid #DBEAFF",
                          paddingRight: 8,
                          paddingLeft: 8,
                        }}
                      >
                        <strong>Name</strong>
                        <p>{selectedLead.name}</p>
                      </Col>

                      <Col
                        span={6}
                        style={{
                          borderRight: "1px solid #DBEAFF",
                          paddingRight: 8,
                          paddingLeft: 8,
                        }}
                      >
                        <strong>Looking For</strong>
                        <p>{selectedLead.lookingFor}</p>
                      </Col>
                      <Col
                        span={6}
                        style={{
                          borderRight: "1px solid #DBEAFF",
                          paddingRight: 8,
                          paddingLeft: 8,
                        }}
                      >
                        <strong>Sq.ft</strong>
                        <p>{selectedLead.sqft}</p>
                      </Col>
                      <Col
                        span={6}
                        style={{
                          paddingLeft: 8,
                        }}
                      >
                        <strong>Location</strong>
                        <p>{selectedLead.location}</p>
                      </Col>
                    </Row>

                    <Row gutter={4} style={{ marginTop: 10 }}>
                      <Col
                        span={6}
                        style={{
                          borderRight: "1px solid #DBEAFF",
                          paddingRight: 8,
                          paddingLeft: 8,
                        }}
                      >
                        <strong>Contact No.</strong>
                        <p>{selectedLead.contact}</p>
                      </Col>
                      <Col
                        span={6}
                        style={{
                          borderRight: "1px solid #DBEAFF",
                          paddingRight: 8,
                          paddingLeft: 8,
                        }}
                      >
                        <strong>Budget</strong>
                        <p>{selectedLead.budget}</p>
                      </Col>
                    <Col span={6} className="search-select-divider col-padding">
  <strong>Preferred location</strong>
  <p>
    {selectedLead?.state || ''}-
    {selectedLead?.district || ''}-
    {selectedLead?.area || ''}--
    {selectedLead?.pincode || ''}
  </p>
</Col>

                      <Col
                        span={6}
                        style={{
                          paddingLeft: 8,
                        }}
                      >
                        <strong>Site Visit</strong>
                        <p>{selectedLead.siteVisit}</p>
                      </Col>
                    </Row>

                    <button
                      style={{
                        background: "blue",
                        color: "white",
                        padding: "6px 12px",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                        marginTop: "16px",
                      }}
                    >
                      Buy Now
                    </button>
                  </Card>
                </>
              ) : (
                <AdminCard
                  name={adminLead.name}
                  place={adminLead.place}
                  rating={adminLead.rating}
                  price={adminLead.price}
                />
              )}
            </Col>
          </Row>
          {afterLogin === true ? (
            <Row gutter={20}>
              <Col span={8}>
                <Title level={4}>Intake</Title>
                {leads
                  .filter((l) => l.status === "Intake")
                  .map((l) => (
                    <LeadCard key={l.id} {...l} />
                  ))}
              </Col>

              <Col span={8}>
                <Title level={4}>Qualified</Title>
                {leads
                  .filter((l) => l.status === "Qualified")
                  .map((l) => (
                    <LeadCard key={l.id} {...l} />
                  ))}
              </Col>

              <Col span={8}>
                <Title level={4}>RNR</Title>
                {leads
                  .filter((l) => l.status === "RNR")
                  .map((l) => (
                    <LeadCard key={l.id} {...l} />
                  ))}
              </Col>
            </Row>
          ) : (
            <>
              <Row gutter={20}>
                <Col span={8}>
                  <Title level={4}>By Villas</Title>
                  <LeadCard
                    name="Villa Lead"
                    place="Rome"
                    rating="3/5"
                    price="500"
                  />
                </Col>
                <Col span={8}>
                  <Title level={4}>By Apartments</Title>
                  <LeadCard
                    name="Apt Lead"
                    place="Berlin"
                    rating="2/5"
                    price="300"
                  />
                </Col>
                <Col span={8}>
                  <Title level={4}>By Flats</Title>
                  <LeadCard
                    name="Flat Lead"
                    place="Tokyo"
                    rating="5/5"
                    price="700"
                  />
                </Col>
              </Row>
            </>
          )}
        </Col>
      </Row>
    </div>
  );
}
